import { faCircleCheck } from '@fortawesome/free-regular-svg-icons';
import { faCircleExclamation, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FaIcon } from '../../common/FaIcon';
import { useTheme } from '@mui/material';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export enum InvitationIconType {
  Info = 'info',
  InfoInactive = 'infoInactive',
  Ok = 'ok',
  Warning = 'warning',
  Other = 'other',
}

interface Props {
  value: string;
  type: InvitationIconType;
  icon?: IconProp
}

export const InvitationEditTabLabel: FC<Props> = ({ value, type, icon }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const config: Record<Exclude<InvitationIconType, InvitationIconType.Other>, { icon: IconProp; color: string }> = {
    [InvitationIconType.Info]:         { icon: faCircleInfo,         color: theme.palette.common.black },
    [InvitationIconType.InfoInactive]: { icon: faCircleInfo,         color: theme.palette.grey[400] },
    [InvitationIconType.Ok]:           { icon: faCircleCheck,        color: theme.palette.success.main },
    [InvitationIconType.Warning]:      { icon: faCircleExclamation,  color: theme.palette.warning.main },
  };

  const { icon: finalIcon, color } = type === InvitationIconType.Other
    ? { icon: icon!, color: theme.palette.common.black }
    : config[type];

  return (
    <div style={{ display: 'flex', gap: '0.35rem', alignItems: 'center' }}>
      <FaIcon icon={finalIcon} color={color} />
      <span>{t('invitation.tabs.' + value)}</span>
    </div>
  );
};
